import { useTheme } from "@emotion/react";
import type { FC, ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export const SupportFieldLabel: FC<Props> = ({ children }) => {
  const theme = useTheme();

  return (
    <span
      css={{
        color: theme.colors.primary,
        fontSize: "0.875rem",
        fontFamily: theme.displayFontFamily,
      }}
    >
      {children}
    </span>
  );
};
